import { useCallback } from "react";
import NavDropdown from "react-bootstrap/NavDropdown";
import { FaUserCircle } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router";
import { EXTERNAL_LOGIN_URL } from "../../../../consts";
import { doLogout } from "../../../../store/reducer/_sessionReducer";
import { getLoggedIn, getLoggedUser } from "../../../../store/selectors";
import "./index.scss";

const UserDetails = () => {
  const dispatch = useDispatch();
  const loggedUser = useSelector(getLoggedUser);
  const loggedIn = useSelector(getLoggedIn);

  const redirectToLogin = useCallback(() => {
    window.location.href = EXTERNAL_LOGIN_URL;
  }, []);

  const handleLogout = useCallback(async () => {
    await dispatch(doLogout());
    redirectToLogin();
  }, [dispatch, redirectToLogin]);

  const renderLogin = useCallback(
    () =>
      loggedIn ? (
        <NavDropdown
          align="end"
          id="userDertailsDD"
          title={<FaUserCircle size="40" />}
        >
          <NavDropdown.Header>
            <div className="mb-2">
              <strong>{loggedUser?.name}</strong>
            </div>
            <div className="mb-1">
              <small>
                <strong>{loggedUser?.email}</strong>
              </small>
            </div>
          </NavDropdown.Header>
          <NavDropdown.Item as={NavLink} to="/perfil">
            Perfil
          </NavDropdown.Item>
          <NavDropdown.Divider />
          <NavDropdown.Item onClick={handleLogout}>Sair</NavDropdown.Item>
        </NavDropdown>
      ) : (
        <FaUserCircle size="48" />
      ),
    [handleLogout, loggedIn, loggedUser]
  );

  return <div className="pdl_component_userdetails">{renderLogin()}</div>;
};

export default UserDetails;
